import { gql } from '@apollo/client';
import { ASSUMPTION_FIELDS } from 'domain/shared/newProject';

export const GET_PROJECT_ASSUMPTION = gql`
  query GetProjectAssumptions($id: ID!) {
    baseProject(id: $id) {
      id
      name
      alias
      assumptions {
        ${ASSUMPTION_FIELDS}
      }
      accessInfo {
        id
        sections {
          section
          allowedActions
        }
      }
    }
  }
`;
